module.exports = __webpack_public_path__ + "img/val2bizlogo.7607c154.jpg";